export const IMMEDIATE_SHOW_DELAY = 0;
